import { focusedConnect } from '../utils/editor';

export const EDITOR_NAME = 'quoteEditor';
export const connectEditor = focusedConnect.bind(null, EDITOR_NAME);
